import api from './api';

export const applyForCard = async (data) => {
  return await api.post('/api/card/apply', data);
};

export const getCardApplications = async () => {
  return await api.get('/api/card/applications');
};

export const assignCardNumber = async (data) => {
  return await api.post('/api/card/assign-number', data);
};

export const loadBalance = async (data) => {
  return await api.post('/api/card/load-balance', data);
};

export const getCardTransactions = async () => {
  return await api.get('/api/card/transactions');
};

export const getCardPaymentHistory = async () => {
  return await api.get('/api/card/payment-history');
};

export const getCardBalance = async (cardNumber) => {
  return await api.get(`/api/card/balance/${cardNumber}`);
};

export const getCardPendingLoads = async () => {
  return await api.get('/api/card/pending-loads');
};

export const markCardTransactionLoaded = async (transactionId) => {
  return await api.put(`/api/card/transactions/${transactionId}/mark-loaded`);
};
